<nx-link>
  <a [href]="data.url" target="_blank" *ngIf="data.url; else noLink">
    {{ data.text | translate }}
  </a>
  <ng-template #noLink>
    {{ data.text | translate }}
  </ng-template>
</nx-link>
